// Storm Desk Live Weather - public configuration only.

export const SITE = {
  name: "Storm Desk Live Weather",
  tagline: "The Storm is On Air.",
  description:
    "Storm Desk is your 24/7 severe weather command center — live chaser broadcasts, Storm Desk Radar with high-res forecast models, and real-time NWS alerts.",
  contactEmail: "stormdeskwx55@gmail.com",
};

export const SOCIALS = [
  { name: "YouTube", href: "https://www.youtube.com/@StormDeskLiveWeather", key: "youtube" },
  { name: "TikTok", href: "https://www.tiktok.com/@storm.desk.live.wx?is_from_webapp=1&sender_device=pc", key: "tiktok" },
  { name: "Instagram", href: "https://www.instagram.com/stormdeskliveweather/", key: "instagram" },
  { name: "Facebook", href: "https://www.facebook.com/stormdeskliveweather", key: "facebook" },
];

// Private operator workspace (PIN gated).
export const OPS_PATH = "/ops";
